import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/core-skills-assessment')({
  beforeLoad() {
    throw redirect({
      to: '/skills-assessment',
    })
  },
})
